import { render, staticRenderFns } from "./MenagemantPage.vue?vue&type=template&id=35fca63d&"
import script from "./MenagemantPage.vue?vue&type=script&lang=js&"
export * from "./MenagemantPage.vue?vue&type=script&lang=js&"
import style0 from "./MenagemantPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports